/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * add comment input
 * @export
 * @interface NewComment
 */
export interface NewComment {
    /**
     * 
     * @type {string}
     * @memberof NewComment
     */
    text: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewComment
     */
    imagePaths?: Array<string>;
}

/**
 * Check if a given object implements the NewComment interface.
 */
export function instanceOfNewComment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function NewCommentFromJSON(json: any): NewComment {
    return NewCommentFromJSONTyped(json, false);
}

export function NewCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
        'imagePaths': !exists(json, 'imagePaths') ? undefined : json['imagePaths'],
    };
}

export function NewCommentToJSON(value?: NewComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'imagePaths': value.imagePaths,
    };
}

